import { QueryClient } from '@tanstack/react-query';

/** ค่าเริ่มต้นร่วมของ React Query — ปรับราย query ได้ที่ hook */
export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: 1,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000)
      },
      mutations: {
        retry: 0
      }
    }
  });
}
